import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LeftNav from './LeftNav';
import MobileNav from './MobileNav';
import './Layout.css';

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const handleLogout = () => {
    setShowProfileMenu(false);
    logout();
    navigate('/');
  };

  return (
    <div className="app-layout">
      <LeftNav />
      <MobileNav />
      <div className="main-content">
        <div className="top-bar">
          <div className="top-bar-left">
            <span className="user-name-display">{user?.name || 'User'}</span>
          </div>
          <div className="top-bar-right">
            <div className="user-credits-badge">
              💎 {user?.image_credits || 0} Credits Left
            </div>
            
            {/* Profile Menu */}
            <div className="profile-menu-container">
              <button 
                className="profile-icon-btn"
                onClick={() => setShowProfileMenu(!showProfileMenu)}
              >
                {user?.picture ? (
                  <img src={user.picture} alt="Profile" className="profile-avatar" />
                ) : (
                  <div className="profile-avatar-placeholder">
                    {user?.name?.charAt(0).toUpperCase() || '👤'}
                  </div>
                )}
              </button>
              
              {showProfileMenu && (
                <div className="profile-dropdown">
                  <div className="dropdown-header">
                    <div className="dropdown-user-info">
                      <strong>{user?.name}</strong>
                      <span className="dropdown-email">{user?.email}</span>
                    </div>
                  </div>
                  <div className="dropdown-divider"></div>
                  <button 
                    className="dropdown-item"
                    onClick={() => {
                      setShowProfileMenu(false);
                      navigate('/profile');
                    }}
                  >
                    <span className="dropdown-icon">⚙️</span>
                    Profile Settings
                  </button>
                  <button 
                    className="dropdown-item"
                    onClick={() => {
                      setShowProfileMenu(false);
                      navigate('/dashboard');
                    }}
                  >
                    <span className="dropdown-icon">📊</span>
                    Dashboard
                  </button>
                  <div className="dropdown-divider"></div>
                  <button 
                    className="dropdown-item logout-item"
                    onClick={handleLogout}
                  >
                    <span className="dropdown-icon">🚪</span>
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="page-content">
          {children}
        </div>
      </div>
      
      {/* Backdrop to close dropdown */}
      {showProfileMenu && (
        <div 
          className="profile-menu-backdrop"
          onClick={() => setShowProfileMenu(false)}
        ></div>
      )}
    </div>
  );
};

export default Layout;
